import { logger } from "@fidget/common/utils";

export const extractDynamicSuggestionsFromContextOld = (context: any): string[] | undefined => {
  try {
    if (!context) {
      return undefined;
    }

    if (!context.lektaContext || typeof context.lektaContext !== "string") {
      return undefined;
    }

    const parsedContext = JSON.parse(context.lektaContext);

    if (!parsedContext || !parsedContext.closer || !parsedContext.closer.dynamicSuggestions) {
      return undefined;
    }

    return parsedContext.closer.dynamicSuggestions as string[];
  } catch (e) {
    logger.error({ message: "Failed to parse message context", error: e }, context);
    return undefined;
  }
};

export const extractDynamicSuggestionsFromContext = (context: any): string[] | undefined => {
  try {
    if (!context) {
      return undefined;
    }

    if (!context.lektaContext || typeof context.lektaContext !== "string") {
      return undefined;
    }

    const parsedContext = JSON.parse(context.lektaContext);

    if (
      !parsedContext ||
      !parsedContext.closer ||
      !parsedContext.closer.richMessage ||
      !parsedContext.closer.richMessage.dynamicSuggestions
    ) {
      return undefined;
    }

    return parsedContext.closer.richMessage.dynamicSuggestions as string[];
  } catch (e) {
    logger.error({ message: "Failed to parse message context", error: e }, context);
    return undefined;
  }
};
